import {doGet, doPost} from "./do-fetch"

/*
 * Data layer for the in-app announcement (190). Mirrors util/achievements.js: thin wrappers over
 * do-fetch that return plain data and never throw at the caller, so an announcement problem can
 * never take a screen down with it.
 *
 * There is no decision-making here. The server decides whether this user should be shown anything
 * (service/announcement.js owns the rule), so this either hands back an announcement or null.
 */

/*
 * The announcement to show, or null -- which is the normal case, not an error.
 * Shape: {title, body, severity, placement, publishedAt}
 */
const fetchAnnouncement = async () => {
	try {
		const res = await doGet('/mini/announcement')
		if (!res.ok) {
			console.error(`fetchAnnouncement failed: ${res.status}`)
			return null
		}
		return await res.json()
	}
	catch (err) {
		console.error('Error fetching announcement', err)
		return null
	}
}

/*
 * Records that it has been shown, so it is shown exactly once.
 *
 * Fire-and-forget by design, like markAchievementsSeen: a failed write means the announcement
 * appears again on the next visit, which is a better outcome than blocking the dismissal.
 */
const markAnnouncementSeen = async () => {
	try {
		await doPost('/mini/announcement/seen')
	}
	catch (err) {
		console.error('Error marking announcement seen', err)
	}
}

export {fetchAnnouncement, markAnnouncementSeen}
